import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=087f4b98&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087f4b98')) {
      api.createRecord('087f4b98', component.options)
    } else {
      api.reload('087f4b98', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=087f4b98&", function () {
      api.rerender('087f4b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/Index.vue"
export default component.exports